import './Header.css';
import React, {Component} from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter } from 'react-router';
import logo from '../Assets/slt-logo.png'
//import { Link } from 'react-router';
const getActiveKey = (pathname) => {
  if (pathname.indexOf('/worksheets') === 0) return '/worksheets';
  if (pathname.indexOf('/users') === 0) return '/users';
  if (pathname.indexOf('/products') === 0) return '/products';
  if (pathname.indexOf('/reports') === 0) return '/reports';
  return null;
}

const Navs=(props)=>{
  const { pathname } = props;
  const activeKey = getActiveKey(pathname);
  if(props.type==='user'){
    return <Nav activeKey={activeKey}>
      <LinkContainer to="/worksheets"><NavItem eventKey="/worksheets">Work Sheets</NavItem></LinkContainer>
      <LinkContainer to="/products"><NavItem eventKey="/products">Products</NavItem></LinkContainer>
    </Nav>
  } else {
    return <Nav activeKey={activeKey}>
      <LinkContainer to="/worksheets"><NavItem eventKey="/worksheets">Work Sheets</NavItem></LinkContainer>
      <LinkContainer to="/users"><NavItem eventKey="/users">Users</NavItem></LinkContainer>
      <LinkContainer to="/products"><NavItem eventKey="/products">Products</NavItem></LinkContainer>
      <LinkContainer to="/reports"><NavItem eventKey="/reports">Reports</NavItem></LinkContainer>
    </Nav>
  }
}
class Header extends Component{
  render(){
    const { location } = this.props;
    const profileActiveKey = location && location.pathname.indexOf('/profile') === 0 ? '/profile' : null;
    return (
      <Navbar style={{borderRadius:'0px'}}>
        <Navbar.Header>
          <Navbar.Brand>
            <img src={logo} alt="slt-logo" />
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
        <Navs type={this.props.user.type} pathname={location && location.pathname}/>
        <Nav pullRight activeKey={profileActiveKey}>
          <LinkContainer to="/profile"><NavItem eventKey="/profile" className="profile">{this.props.user.name}</NavItem></LinkContainer>
           <NavItem className="logout" onClick={this.props.logout}>Logout</NavItem> 
        </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default withRouter(Header);
